import { takeEvery } from "redux-saga/effects";

import { BillingDocumentAction } from "actions";

import { INTEREST_PREVIEW } from "constants/actionTypes";

import { getBillingDocuments, getInterestPreviewById } from "selectors";

import { fetchMissingByIdFactory } from "./lib";

// BUSINESS_BALANCE rows have no billingDocumentId -- excluded here so they
// don't get requested as a billing document with id undefined.
const getPerDocumentInterestPreviewById = (
  state: State,
): Record<string, InterestPreviewData> =>
  Object.fromEntries(
    Object.entries(getInterestPreviewById(state)).filter(
      ([, interestPreview]) => interestPreview.billingDocumentId,
    ),
  );

export const fetchMissingBillingDocuments = fetchMissingByIdFactory(
  getPerDocumentInterestPreviewById,
  getBillingDocuments,
  interestPreview => interestPreview.billingDocumentId,
  billingDocumentIds =>
    BillingDocumentAction.requestSome({ billingDocumentIds }),
);

export default function* interestPreviewSaga() {
  yield takeEvery(
    INTEREST_PREVIEW.FETCH_BULK.SUCCESS,
    fetchMissingBillingDocuments,
  );
}
